"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BuffType = void 0;
var BuffType;
(function (BuffType) {
    // buffs. positive effects. generally unique.
    BuffType["Buff"] = "buff";
    // debuffs. negative effects/dots. sometimes unique.
    BuffType["Debuff"] = "debuff";
    // outgoing modifiers. used to modify your own outgoing damage.
    BuffType["OutgoingModifier"] = "outgoing";
    // incoming modifiers. used to modify incoming damage.
    BuffType["IncomingModifier"] = "incoming";
})(BuffType || (exports.BuffType = BuffType = {}));
